import { render, staticRenderFns } from "./CreateNewTier.vue?vue&type=template&id=7892564a&scoped=true"
import script from "./CreateNewTier.vue?vue&type=script&lang=js"
export * from "./CreateNewTier.vue?vue&type=script&lang=js"
import style0 from "./CreateNewTier.vue?vue&type=style&index=0&id=7892564a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7892564a",
  null
  
)

export default component.exports